import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Async from "react-select";

const PrintYarnForm = props => {
  return (
    <div class="col-md-12  text-center">
      <div className="col-md-12 d-flex justify-content-center p-2">
        <div className="col-md-1">
          <label>Customer department</label>
        </div>
        <div className="col-md-4" style={{ zIndex: 1000 }}>
          <App
            customerInfo={props.customerWithDepartment}
            selectedCustomers={props.storeCustomerData}
          />
        </div>
        <div className="col-md-1">
          <label>supplier</label>
        </div>
        <div className="col-md-4">
          <div class="custom-async-select height-adjust">
            <Async
              name="supplierName"
              value={props.supplierName}
              // onInputChange={this.getSupplierInfo}
              onChange={props.changeSupplierInfo}
              placeholder="Find Suppliername"
              options={props.supplierOption}
              disabled={false}
            />
          </div>
        </div>
        </div>
        <div className="col-md-12 d-flex justify-content-center p-1">
        <div className="col-md-1">
          <label>Requirement</label>
        </div>
        <div className="col-md-4 height-adjust">
          <Field
            inputType="select"
            inputName="requirement"
            value={props.requirement}
            options={props.requirementOption}
            onChange={props.updateReportType}
            disabled={false}
            className="Select-control"
          />
        </div>
        <div className="col-md-1">
          <label>Status</label>
        </div>
        <div className="col-md-4 height-adjust">
          <Field
            inputType="select"
            inputName="status"
            value={props.status}
            options={props.statusOptions}
            onChange={props.updateReportType}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
      {/* <div className="container row w-100">
        <div
          className="d-flex flex-column align-items-center justify-content-center col-md-12 p-2"
          style={{ zIndex: "1000" }}
        >
          <label>Customer department</label>
          <App
            customerInfo={props.customerWithDepartment}
            selectedCustomers={props.storeCustomerData}
          />
        </div>
      </div> */}
    </div>
  );
};

export default PrintYarnForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/PrintYarnForm.js